import React from "react";
import { Modal, Offcanvas } from "react-bootstrap";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import Select from "react-select";
import { options1 } from "../../../core/common/selectoption/selectoption";
import Table from "../../../core/common/dataTable/index";
import { TableData } from "../../../core/data/interface";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import CollapseHeader from "../../../core/common/collapse-header";
import { all_routes } from "../../router/all_routes";
import { useState, useEffect } from "react";
import { updateStage, addStage, deleteStage, addPipeline, updatePipeline, deletePipeline, getPipeline, getAllPipelines, usingPipeline, updateStageOrder } from "./pipelineAPI";
import ResponseModal from "../../../core/modals/response_modal";

interface Stage {
  id?: number;
  orderId: number;
  name: string;
}

interface Pipeline {
  pipelineName: string;
  createdBy: string;
  createdAt: string;
  updateAt: string;
  updateBy: string;
  status: string;
  id: number;
  type: string;
  stages: Stage[];
}

const route = all_routes;
const Pipeline = () => {
  const [openModal, setOpenModal] = useState(false);
  const [stages, setStages] = useState<Stage[]>([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [selectedPipeline, setSelectedPipeline] = useState<number | null>(null);
  const [newStageName, setNewStageName] = useState("");
  const [selectedType, setSelectedType] = useState<string>("LEAD");
  const [selectedStatus, setSelectedStatus] = useState<string>("INACTIVE");
  const [editingStageId, setEditingStageId] = useState<number | null>(null);
  const [pipelineName, setPipelineName] = useState<string>("");
  const [pipelines, setPipelines] = useState<Pipeline[]>([]);

  const handleAddStageToLocal = () => {
    if (!newStageName.trim()) {
      setResponse({ status: "error", message: "Stage name cannot be empty!" });
      setShowMessageModal(true);
      return;
    }
    let lastId = Number(localStorage.getItem("lastStageId")) || 0;
    lastId += 1;
    const newStage: Stage = { orderId: lastId, name: newStageName };
    const updatedStages = [...stages, newStage];
    setStages(updatedStages);
    localStorage.setItem("stages", JSON.stringify(updatedStages));
    localStorage.setItem("lastStageId", String(lastId));
    setNewStageName("");
    closeModal();
  };

  const handleUpdateStageInLocal = () => {
    if (!newStageName.trim()) {
      setResponse({ status: "error", message: "Stage name cannot be empty!" });
      setShowMessageModal(true);
      return;
    }

    setStages((prevStages) =>
      prevStages.map((stage) =>
        stage.orderId === editingStageId
          ? { ...stage, name: newStageName }
          : stage
      )
    );
    setEditingStageId(null);
    setNewStageName("");
    closeModal();
  };

  const handleDeleteStageFromLocal = (stageId: number) => {
    setStages((prevStages) => prevStages.filter((stage) => stage.orderId !== stageId));
    setEditingStageId(null);
    closeModal();
  };


  const closeModal = () => {
    const closeButton = document.querySelector('[data-bs-dismiss="modal"]') as HTMLButtonElement;
    if (closeButton) {
      closeButton.click();
    }
  };

  const handleCreatePipeline = async () => {
    try {
      if (!pipelineName.trim()) {
        setResponse({ status: "error", message: "Pipeline name cannot be empty!" });
        setShowMessageModal(true);
        return;
      }
      if (stages.length === 0) {
        setResponse({ status: "error", message: "Please add at least one stage before creating a pipeline." });
        setShowMessageModal(true);
        return;
      }
      const payload = {
        pipelineName,
        type: selectedType,
        status: selectedStatus,
        pipelineStages: stages.map(({ name, orderId }) => ({
          stageName: name,
          order: orderId,
        })),
      };

      console.log("Final Payload:", JSON.stringify(payload, null, 2));

      const response = await addPipeline(payload);
      console.log("API Response:", response);

      if (!response || response.status !== 200) {
        setResponse({ status: "error", message: "Failed to create pipeline. Please try again." });
        return;
      } else {
        setOpenModal(true);
        fetchPipelines();
        localStorage.removeItem("stages");
        localStorage.removeItem("lastStageId");
        setPipelineName("");
        setSelectedType("LEAD");
        setSelectedStatus("INACTIVE");
        setStages([]);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  useEffect(() => {
    const storedStages = JSON.parse(localStorage.getItem("stages") || "[]");
    setStages(storedStages);
  }, []);

  const handleAddStage = async (event: React.FormEvent) => {
    try {
      event.preventDefault();
      if (newStageName.trim() === "") {
        setResponse({ status: "error", message: "Stage name cannot be empty!" });
        setShowMessageModal(true);
        return;
      }
      const response = await addStage(newStageName, selectedPipeline);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Stage added successfully!" });
        setNewStageName("");
        setShowMessageModal(true);
      }
      if (selectedPipeline) {
        const response = await getPipeline(selectedPipeline);
        setStages(response.data.data.pipelineStages);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  useEffect(() => {
    if (!selectedPipeline) return;

    const fetchPipeline = async () => {
      try {
        const response = await getPipeline(selectedPipeline);
        if (response?.data?.code === 200) {
          console.log("Pipeline Data:", response.data.data);
          setPipelineName(response.data.data.pipelineName || "");
          setSelectedType(response.data.data.type || "LEAD");
          setSelectedStatus(response.data.data.status || "INACTIVE");
          if (Array.isArray(response.data.data.pipelineStages)) {
            const stageList: Stage[] = response.data.data.pipelineStages.map((stage: any) => ({
              id: stage.id,
              name: stage.name,
              orderId: stage.order,
            }));
            setStages(stageList);
          } else {
            setStages([]);
          }
        } else {
          console.log("Error: Pipeline not found.");
          setPipelineName("");
          setStages([]);
        }
      } catch (error) {
        console.error("Error fetching pipeline:", error);
        setPipelineName("");
        setStages([]);
      }
    };

    fetchPipeline();
  }, [selectedPipeline]);

  const handleUpdateStage = async () => {
    try {
      if (!newStageName.trim()) {
        setResponse({ status: "error", message: "Stage name cannot be empty!" });
        setShowMessageModal(true);
        return;
      }

      await updateStage(editingStageId, newStageName);
      setStages((prevStages) =>
        prevStages.map((stage) =>
          stage.id === editingStageId ? { ...stage, name: newStageName } : stage
        )
      );
      setEditingStageId(null);
      setNewStageName("");
      document.getElementById("edit_stage")?.click();
      setResponse({ status: "success", message: "Stage updated successfully!" });
    }catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const handleEditPipeline = async (pipelineId: number) => {
    try {
      console.log("Fetching pipeline for ID:", pipelineId);
      setSelectedPipeline(pipelineId);

      const response = await getPipeline(pipelineId);
      console.log("API Response:", response);

      if (response?.data?.code === 200) {
        console.log("Pipeline Data:", response.data.data);
        setPipelineName(response.data.data.pipelineName || "");

        if (Array.isArray(response.data.data.pipelineStages)) {
          const stageList: Stage[] = response.data.data.pipelineStages.map((stage: any) => ({
            id: stage.id,
            name: stage.name,
            orderId: stage.order,
          }));

          console.log("Processed Stages:", stageList);
          setStages(stageList);
        } else {
          console.log("No stages found.");
          setStages([]);
        }
      } else {
        console.log("Error: Pipeline not found.");
        setResponse({ status: "error", message: "Pipeline not found." });
        setPipelineName("");
        setStages([]);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
        setPipelineName("");
        setStages([]);
      }
    }
  };

  const handleDeleteStage = async (stageId: number) => {
    try {
      if (!stageId) {
        setResponse({ status: "error", message: "Stage ID not exist" });
        return;
      }
      console.log("Deleting stage with ID:", stageId);
      await deleteStage(stageId);
      setStages((prevStages) => prevStages.filter((stage) => stage.id !== stageId));
      setEditingStageId(null);
      setResponse({ status: "success", message: "Stage deleted successfully!" });
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const handleUpdatePipeline = async () => {
    try {
      if (!selectedPipeline || !pipelineName.trim()) {
        setResponse({ status: "error", message: "Pipeline name cannot be empty!" });
        setShowMessageModal(true);
        return;
      }
      const updatedPipeline = {
        pipelineName: pipelineName,
        type: selectedType,
        status: selectedStatus,
      };
      const response = await updatePipeline(selectedPipeline, updatedPipeline);
      if (response.status === 200) {
        fetchPipelines();
        setResponse({ status: "success", message: "Pipeline updated successfully!" });
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const [deletingPipelineId, setDeletingPipelineId] = useState<number | null>(null);
  const handleDeletePipeline = async () => {
    try {
      if (!deletingPipelineId) {
        setResponse({ status: "error", message: "No pipeline selected for deletion!" });
        return;
      }

      console.log("Deleting Pipeline ID:", deletingPipelineId);

      const response = await deletePipeline(deletingPipelineId);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Pipeline deleted successfully!" });
        setDeletingPipelineId(null);
        fetchPipelines();
        setShowMessageModal(true);
      }
      document.getElementById("closeDeleteModal")?.click();
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const fetchPipelines = async () => {
    try {
      const response = await getAllPipelines();
      if (response.data.data && response.data.data.content) {
        setPipelines(response.data.data.content.map((item: any) => ({ ...item, key: item.id })));
      }
    } catch (error) {
      console.error("Error fetching pipelines:", error);
    }
  };

  const handleSetPipeline = async (pipelineId: number) => {
    try {
      const response = await usingPipeline(pipelineId, "ACTIVE");
      if (response.status === 200) {
        fetchPipelines();
        setResponse({ status: "success", message: "Pipeline set to ACTIVE successfully!" });
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const handleMoveStageUp = (stageId: number) => {
    setStages((prevStages) => {
      const index = prevStages.findIndex((stage) => stage.id === stageId);
      if (index > 0) {
        const updatedStages = [...prevStages];
        const [movedStage] = updatedStages.splice(index, 1);
        updatedStages.splice(index - 1, 0, movedStage);

        // Update the orderId values for all stages
        const reorderedStages = updatedStages.map((stage, idx) => ({
          ...stage,
          orderId: idx + 1,
        }));

        const payload = reorderedStages.map((stage) => ({
          id: stage.id,
          order: stage.orderId,
        }));

        console.log("Payload for moving up:", payload);
        updateStageOrder(payload);
        return reorderedStages;
      }
      return prevStages; // Return the original state if no changes are made
    });
  };

  const handleMoveStageDown = (stageId: number) => {
    setStages((prevStages) => {
      const index = prevStages.findIndex((stage) => stage.id === stageId);
      if (index < prevStages.length - 1) {
        const updatedStages = [...prevStages];
        const [movedStage] = updatedStages.splice(index, 1);
        updatedStages.splice(index + 1, 0, movedStage);

        // Update the orderId values for all stages
        const reorderedStages = updatedStages.map((stage, idx) => ({
          ...stage,
          orderId: idx + 1,
        }));

        const payload = reorderedStages.map((stage) => ({
          id: stage.id,
          order: stage.orderId,
        }));

        console.log("Payload for moving down:", payload);
        updateStageOrder(payload);
        return reorderedStages;
      }
      return prevStages; // Return the original state if no changes are made
    });
  };

  useEffect(() => {
    fetchPipelines();
  }, []);


  const columns = [
    {
      title: "Pipeline Name",
      dataIndex: "pipelineName",
      sorter: (a: Pipeline, b: Pipeline) => a.pipelineName.localeCompare(b.pipelineName),
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: (a: Pipeline, b: Pipeline) => a.type.localeCompare(b.type),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      sorter: (a: Pipeline, b: Pipeline) => a.createdBy.localeCompare(b.createdBy),
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      sorter: (a: Pipeline, b: Pipeline) => a.createdAt.localeCompare(b.createdAt),
      render: (createdAt: string) => {
        const formattedDate = new Date(createdAt);
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDateString = new Intl.DateTimeFormat('en-GB', options).format(formattedDate);
        return <span>{formattedDateString}</span>;
      },
    },

    {
      title: "Modified By",
      dataIndex: "updatedBy",
      sorter: (a: Pipeline, b: Pipeline) => a.updateBy.localeCompare(b.updateBy),
    },
    {
      title: "Modified Date",
      dataIndex: "updatedAt",
      sorter: (a: Pipeline, b: Pipeline) => a.updateAt.localeCompare(b.updateAt),
      render: (updatedAt: string) => {
        const formattedDate = new Date(updatedAt);
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDateString = new Intl.DateTimeFormat('en-GB', options).format(formattedDate);
        return <span>{formattedDateString}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: Pipeline, b: Pipeline) => a.status.localeCompare(b.status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: Pipeline) => (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <button
              className="dropdown-item"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_edit"
              onClick={() => handleEditPipeline(record.id)}
            >
              <i className="ti ti-edit text-blue"></i> Edit
            </button>
            <button
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#delete_pipeline"
              onClick={() => setDeletingPipelineId(record.id)}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </button>
            <button
              className="dropdown-item"
              onClick={() => handleSetPipeline(record.id)}
            >
              <i className="ti ti-clipboard-text text-blue-light"></i> Set Pipeline
            </button>
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      Pipeline<span className="count-title">{pipelines.length}</span>
                    </h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-body">
                  <>
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown">
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_pipeline"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Pipeline
                        </Link>
                      </div>
                    </div>
                    {/* /Filter */}
                  </>

                  {/* Pipeline List */}
                  <div className="table-responsive custom-table">
                    <Table dataSource={pipelines} columns={columns} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Pipeline List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
        {/* /Add New Pipeline */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_pipeline"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Add New Pipeline</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form>
              {/* Pipeline Name */}
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Pipeline Name"
                  value={pipelineName}
                  onChange={(e) => setPipelineName(e.target.value)}
                />
              </div>

              {/* Select Type */}
              <div className="mb-3">
                <label className="col-form-label">Type</label>
                <select
                  className="form-select"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="LEAD">LEAD</option>
                  <option value="OPPORTUNITY">OPPORTUNITY</option>
                </select>
              </div>

              {/* Pipeline Stages */}
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <button
                    type="button"
                    className="btn btn-link add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage_local"
                  >
                    Add New
                  </button>
                </div>
                <div className="pipeline-listing">
                  {Array.isArray(stages) && stages.length > 0 ? (
                    stages.map((stage) => (
                      <div key={stage.id || stage.orderId} className="pipeline-item">
                        <p>{stage.name}</p>
                        <div className="action-pipeline">
                          <button
                            className="btn btn-sm text-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_stage_local"
                            onClick={(e) => {
                              e.preventDefault();
                              setEditingStageId(stage.id || stage.orderId);
                              setNewStageName(stage.name);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm text-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_stage_local"
                            onClick={(e) => {
                              e.preventDefault();
                              setEditingStageId(stage.id || stage.orderId);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No stages available</p>
                  )}
                </div>
              </div>

              {/* Status Radio Buttons */}

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-end">
                <button type="button" data-bs-dismiss="offcanvas" className="btn btn-light me-2">
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleCreatePipeline}>
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add New Pipeline */}
      </>
      <>
        {/* Edit Pipeline */}
        <div className="offcanvas offcanvas-end offcanvas-large" tabIndex={-1} id="offcanvas_edit">
          <div className="offcanvas-header border-bottom">
            <h4>Edit Pipeline - {pipelineName}</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpdatePipeline();
              }}
            >
              {/* Pipeline Name */}
              <div className="mb-3">
                <label className="col-form-label">Pipeline Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={pipelineName}
                  onChange={(e) => setPipelineName(e.target.value)}
                />
              </div>

              {/* Select Type */}
              <div className="mb-3">
                <label className="col-form-label">Type</label>
                <select
                  className="form-select"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="LEAD">LEAD</option>
                  <option value="OPPORTUNITY">OPPORTUNITY</option>
                </select>
              </div>

              {/* Pipeline Stages */}
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Stages in {pipelineName}</h5>
                  <button
                    type="button"
                    className="btn btn-link add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    Add New
                  </button>
                </div>

                <ul>
                  {Array.isArray(stages) && stages.length > 0 ? (
                    stages.map((stage, index) => (
                      <li key={stage.id || stage.orderId}>
                        <div className="pipeline-listing">
                          <div className="pipeline-item" style={{ padding: "10px 15px" }}>
                            <p style={{ margin: 0, padding: 0 }}>{stage.name}</p>
                            <div className="action-pipeline">
                              <button
                                className="btn btn-sm text-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_stage"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEditingStageId(stage.id || 0);
                                  setNewStageName(stage.name);
                                }}
                              >
                                Edit
                              </button>

                              <button
                                className="btn btn-sm text-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_stage"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEditingStageId(stage.id || 0);
                                }}
                              >
                                Delete
                              </button>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginLeft: "10px",
                                  height: "40px"
                                }}
                              >
                                {index > 0 && <button
                                  className="btn btn-sm"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleMoveStageUp(stage.id || 0);
                                  }}
                                >
                                  <i className="fa-solid fa-chevron-up"></i>
                                </button>}
                                {index < stages.length - 1 && <button
                                  className="btn btn-sm"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleMoveStageDown(stage.id || 0);
                                  }}
                                >
                                  <i className="fa-solid fa-chevron-down"></i>
                                </button>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <p className="text-muted">No stages available</p>
                  )}
                </ul>
              </div>

              {/* Status Radio Buttons */}
              {/* <div className="mb-3">
                <label className="col-form-label">Status</label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      value="ACTIVE"
                      checked={selectedStatus === "ACTIVE"}
                      onChange={() => setSelectedStatus("ACTIVE")}
                    />
                    <label className="form-check-label">Active</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      value="INACTIVE"
                      checked={selectedStatus === "INACTIVE"}
                      onChange={() => setSelectedStatus("INACTIVE")}
                    />
                    <label className="form-check-label">Inactive</label>
                  </div>
                </div>
              </div> */}

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-end">
                <button type="button" className="btn btn-light me-2" data-bs-dismiss="offcanvas">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Pipeline */}
      </>
      <>
        {/* Delete Stage */}
        <div className="modal fade" id="delete_stage" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Stage?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> the selected stage?
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        if (editingStageId !== null) {
                          handleDeleteStage(editingStageId);
                        }
                      }}
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete it
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* /Delete Stage */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form >
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-danger" data-bs-dismiss="offcanvas">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        {/* Add New Stage */}
        <div className="modal custom-modal fade" id="add_stage" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Stage</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="ti ti-x" /></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddStage}>
                  <div className="mb-3">
                    <label className="col-form-label">Stage Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={newStageName}
                      onChange={(e) => setNewStageName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="modal-btn text-end">
                    <button type="button" className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" className="btn btn-primary">Save Changes</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New Stage */}
        {/* Add New Stage (Local) */}
        <div className="modal custom-modal fade" id="add_stage_local" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingStageId ? "Edit Stage" : "Add New Stage"}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="ti ti-x" /></button>
              </div>
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    editingStageId ? handleUpdateStageInLocal() : handleAddStageToLocal();
                  }}
                >
                  <div className="mb-3">
                    <label className="col-form-label">Stage Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={newStageName}
                      onChange={(e) => setNewStageName(e.target.value)}
                    />
                  </div>
                  <div className="modal-btn text-end">
                    <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {editingStageId ? "Update Stage" : "Add Stage"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New Stage (Local) */}
        {/* Edit Stage */}
        <div className="modal custom-modal fade" id="edit_stage" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Stage</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="ti ti-x" /></button>
              </div>
              <div className="modal-body">
                <form onSubmit={(e) => { e.preventDefault(); handleUpdateStage(); }}>
                  <div className="mb-3">
                    <label className="col-form-label">Stage Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={newStageName}
                      onChange={(e) => setNewStageName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="modal-btn text-end">
                    <button type="button" className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Save Changes</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* /Edit Stage */}
      </>
      {/* Delete Stage (Local) */}
      <div className="modal fade" id="delete_stage_local" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Stage?</h4>
                <p className="mb-0">Are you sure you want to remove this stage?</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      if (editingStageId !== null) {
                        handleDeleteStageFromLocal(editingStageId);
                        setEditingStageId(null);
                        document.getElementById("delete_stage_local")?.classList.remove("show");
                        document.body.classList.remove("modal-open");
                      }
                    }}
                  >
                    Yes, Delete it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Stage (Local) */}
      {/* Edit Stage (Local) */}
      <div className="modal custom-modal fade" id="edit_stage_local" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="ti ti-x" /></button>
            </div>
            <div className="modal-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleUpdateStageInLocal();
                }}
              >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newStageName}
                    onChange={(e) => setNewStageName(e.target.value)}
                    required
                  />
                </div>
                <div className="modal-btn text-end">
                  <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Save Changes</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage (Local) */}
      {/* Delete Pipeline */}
      <div className="modal fade" id="delete_pipeline" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Pipeline?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> pipeline you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-danger"
                    onClick={() => handleDeletePipeline()}
                    data-bs-dismiss="modal" >
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Pipeline */}
      <Modal show={openModal} onHide={() => { setOpenModal(false); window.location.reload() }}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Pipeline Created Successfully!!!</h3>
            <button
              className="btn btn-primary w-60"
              onClick={() => {
                setOpenModal(false);
                window.location.reload();
              }
              }
            >
              Ok
            </button>

          </div>
        </div>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </>
  );
};

export default Pipeline;
